<template><!-- 商品頁保障內容tab -->
    <div id="assure">
        <div class="container">
            <h2 class="title">保障內容</h2>
                <tabs :options="{ useUrlFragment: false }">
                  <tab v-for="(tab, index) in tabContents" :name="tab.tab_title" :title="tab.tab_title" :key="index"
                       :nav-item-link-class="'assure_tab_accu' + index">
                    <p class="gray">保險項目</p>
                    <h3 v-html="tab.tab_contentTitle"></h3>
                    <div class="line"></div>
                    <div v-html="tab.tab_content"></div>
                    <div class="button-pane">
                        <p>
                            詳細承保內容請以「保單及條款」上所記載為準
                        </p>
                      <a href="https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html" class="btn" target="_blank"
                         :class="'assure_info_accu' + index">瞭解更多</a>
                    </div>
                  </tab>
                </tabs>
        </div>
    </div>
</template>
<script setup>
import {onMounted, reactive} from "vue";
import $ from "jquery"

    const  tabContents = reactive([
        {
            tab_title: "旅行平安保險",
            tab_contentTitle:"旅行平安保險",
            tab_content:"<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>意外死亡及失能</p><p>300萬~500萬</p></li><li><p>傷害醫療</p><p>5萬</p></li><li><p>意外喪葬費用及失能(限15歲以下)</p><p>最高69萬</p></li><li><p>個人賠償責任保險(每一事故自負額2,500元)</p><p>體傷20萬/財損10萬/保期內最高60萬</p></li></ul>"
        },
        {
            tab_title: "國內旅遊不便險",
            tab_contentTitle:"國內旅遊不便險",
            tab_content:
                "<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>境內班機延誤保險金(定額)</p><p>2,000元</p></li><li><p>境內旅程取消或縮短保險(限額)</p><p>1萬元</p></li><li><p>境內劫持補償費用保險(定額)</p><p>1萬元</p></li><li><p>旅行期間行動電話強盜搶奪補償保險</p><p>3,000元</p></li><li><p>食物中毒慰問保險金(定額)</p><p>3,000元</p></li><li><p>旅行期間居所動產損失保險(限額)(每一事故自負額5,000元)</p><p>10萬</p></li><li><p>旅行期間居家竊盜保險(限額)</p><p>5萬元</p></li><li><p>旅行期間居家火災臨時住宿補償保險(定額)</p><p>1萬元</p></li><li><p>旅行期間居所第三人責任保險(限額)</p><p>30萬元</p></li></ul>"
        },
        {
            tab_title: "交通事故保險",
            tab_contentTitle:"交通事故保險",
            tab_content:
                "<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>大眾運輸事故死亡及失能(限15歲以上投保)</p><p>100萬元</p></li><li><p>國道交通事故死亡及失能(限15歲以上投保)</p><p>100萬元</p></li></ul>"
        },
        // {
        //     tab_title: "重大燒燙傷保險",
        //     tab_contentTitle:"重大燒燙傷保險(限回傳要保書投保)",
        //     tab_content:
        //         "<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>重大燒燙傷(限額)</p><p>100萬元</p></li></ul>"
        // },
        {
            tab_title: "租車旅遊保險",
            tab_contentTitle:"租車旅遊保險",
            tab_content:
                "<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>車對車碰撞車體損失責任保險(限額)</p><p>5萬元</p></li><li><p>第三人責任保險-每一人體傷/每一意外事故(限額)</p><p>10萬元/20萬元</p></li><li><p>第三人責任保險-第三人財損(限額)</p><p>3萬元</p></li></ul>"
        },
        {
            tab_title: "三鐵活動保險",
            tab_contentTitle:"三鐵活動保險",
            tab_content:
                "<ul><li><p class='gray'>保障項目</p><p class='gray'>保障內容</p></li><li><p>特定事故傷害醫療保險(熱痙攣/中暑等特定事故醫療)</p><p>5萬</p></li><li><p>境內急難救助保險(搜索救助/醫療運送/親人前往處理)(限額)</p><p>30萬/5萬/5萬元</p></li></ul>"
        }
    ]);
    const addTabsFrame = () => {
        $('.tabs-component-tabs').wrap("<div class='tabs-component--wrap'></div>")//套件的ul外面包一層div overflow-x才有用
    }
    onMounted(() => {
        addTabsFrame()
    })

</script>

<style lang="scss">
$border: #EBECED;
#assure {
  padding: 50px 0;
  background: $blue-400;

  .title {
    padding: 30px 0;
  }

  .title h2 {
    padding: 0;
    font-size: 40px;
    @media screen and (max-width: $padMini) {
      font-size: 30px;
    }
  }

  .tabs-component {
    margin: 0 0 20px;
    .tabs-component--wrap{
      margin-bottom:30px;
    }
    @media screen and (max-width: $padMini) {
      .tabs-component--wrap{overflow-x: auto;}

    }

    .tabs-component-tabs {
      list-style: none;
      margin: 0 0 10px;
      padding: 0;
      text-align: center;
        justify-content: center;
      width: 100%;
      display: flex;
      @media screen and (max-width: $pad) {
        display: flex;
        overflow-x: auto;
      }
      @media screen and (max-width: $small) {
        width: 650px;
        display: block;
      }

      li {
        cursor: pointer;
        align-items: center;
        font-weight: 600;
        display: inline-block;
        position: relative;
        transition: 0.1s ease-in-out;
        text-decoration: none;
        width: 180px;
        margin: 0 5px;
        @media screen and (max-width: $padLandscape) {
          width: 150px;
          font-size: 20px;
          margin: 0 5px;
        }
        @media screen and (max-width: $small) {
          width: 120px;
          float:left;

        }
        a {
          color: $blue-700;
          display: block;
          padding: 5px 15px;
          box-sizing: border-box;
          border: 2px solid $border;
          border-radius: $radius;
          font-size:30px;
          background-color: #fff;
          &:hover,
          &:focus {
            background: $blue-700;
            border: 2px solid $blue-700;
            color: #fff;
          }
          @media screen and (max-width: $padLandscape) {
            font-size:25px;
          }
          @media screen and (max-width: $pad) {
            font-size: 18px;
            width: 100%;
            border-radius: 10px;
          }
        }
        .is-active {
          position: relative;
          background: $blue-700;
          z-index: 1;
          border: 2px solid $blue-700;
          color: $mainColor
        }
      }
    }
  }

  .tabs-component-panels section{
    background-color: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
    clear: both;
    border-radius: $radius;
    border: 2px solid #EBECED;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-weight: 500;
    overflow: hidden;
    color: $textColor;

    p.right {
      margin: 10px 0;
    }

    h3 {
      font-size: 30px;
      color: $blue-700;
      @media screen and (max-width: $padMini) {
        font-size: 25px;
      }

      br {
        display: none;
      }
    }

    ul {
      display: block;
    }

    li {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      line-height: 40px;
      width: 100%;
      @media screen and (max-width: $pad) {
        font-size: 15px;
        margin: 15px 0;
        p {
          &:first-child {
            width: 59%;
            text-align: left;
            line-height: 20px;
          }

          &:last-child {
            width: 40%;
            line-height: 20px;
            text-align: right;
          }
        }
      }
    }

    a {
      transition: color 200ms ease;
      text-align: center;

      &:hover,
      &:focus {
        background: #fd0452;
      }
    }

    hr {
      margin: 3rem 0;
      border: 1px solid transparent;
      border-radius: 50%;
      border-top-color: $border;
    }

    .gray {
      color: $gray;
      font-weight: 400;
    }

    .button-pane {
      text-align: center;
      margin-top: 40px;

      p {
        color: $gray;
      }

      a.btn {
        margin: 30px auto;
      }

      @media screen and (max-width: $padMini) {
        font-size: 14px;
      }

      @media screen and (max-width: $small) {
        & + p.right {
          float: none;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }
}

.overseaTitle {
  h3 {
    display: inline-block
  }

  span {
    display: inline;
  }

  @media screen and (max-width: $small) {
    span {
      display: block;
    }
  }
}

</style>